import { SalesChannelType } from '../../custom-hooks/useQueryRMSSalesChannels';

export function getSalesChannelType(salesChannelType: string, wrapInBrackets = true): string {
  switch (salesChannelType) {
    case SalesChannelType.POS:
      return wrapInBrackets ? ' [POS]' : 'POS';
    case SalesChannelType.UBER_EATS:
      return wrapInBrackets ? ' [Uber]' : 'Uber';
    case SalesChannelType.DELIVEROO:
      return wrapInBrackets ? ' [Deliveroo]' : 'Deliveroo';
    case SalesChannelType.JUST_EATS:
      return wrapInBrackets ? ' [JustEat]' : 'JustEat';
    case SalesChannelType.FLIPDISH_WEB_APP:
      return wrapInBrackets ? ' [Web]' : 'Web';
    case SalesChannelType.FLIPDISH_KIOSK:
      return wrapInBrackets ? ' [Kiosk]' : 'Kiosk';
    case SalesChannelType.FLIPDISH_MOBILE_APP:
      return wrapInBrackets ? ' [Apps]' : 'Apps';
    case SalesChannelType.EXTERNAL_APP:
      return wrapInBrackets ? ' [ExternalApp]' : 'ExternalApp';
    case SalesChannelType.WEB_APP:
      return wrapInBrackets ? ' [WebApp]' : 'WebApp';
    case SalesChannelType.MOBILE_APP:
      return wrapInBrackets ? ' [MobileApp]' : 'MobileApp';
    default:
      return '';
  }
}
